export const DEFAULT_CHAIN_IDS = [
  1, 5, 11155111, 137, 80001, 56, 97, 43114, 43113, 250, 25, 338, 1337,
];
